import { render, staticRenderFns } from "./Incrementor.vue?vue&type=template&id=042f2dd6&scoped=true"
import script from "./Incrementor.vue?vue&type=script&lang=js"
export * from "./Incrementor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f2dd6",
  null
  
)

export default component.exports